import { render, staticRenderFns } from "./ReturnsForm.vue?vue&type=template&id=96a22de4&scoped=true&"
import script from "./ReturnsForm.vue?vue&type=script&lang=js&"
export * from "./ReturnsForm.vue?vue&type=script&lang=js&"
import style0 from "./ReturnsForm.vue?vue&type=style&index=0&id=96a22de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a22de4",
  null
  
)

export default component.exports